import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Loading,
  OrdersRepository,
  GetOrdersResult,
  Order,
  OrderState,
} from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type OrdersState = {
  loading: Loading;
  orders: Order[];
  ordersCount: number;
  pageSize: number;
};

const initialState: OrdersState = {
  loading: "idle",
  orders: [],
  pageSize: 0,
  ordersCount: 0,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    ordersLoading(state) {
      state.loading = "pending";
    },
    ordersLoaded(state, { payload }: PayloadAction<GetOrdersResult>) {
      const { pageSize, ordersCount, orders } = payload;
      state.pageSize = pageSize;
      state.ordersCount = ordersCount;
      state.orders = orders;
      state.loading = "succeeded";
    },
    ordersFailed(state) {
      state.loading = "failed";
    },
  },
});

export default ordersSlice.reducer;

const { ordersFailed, ordersLoaded, ordersLoading } = ordersSlice.actions;

export const loadOrders = (
  page: number,
  state: OrderState | "ALL" = "ALL",
  startDate?: string,
  endDate?: string,
  search?: string
): AppThunk => async (dispatch) => {
  dispatch(ordersLoading());
  const res = await ServiceLocater.get<OrdersRepository>(
    Services.OrdersRepository
  ).list(page, state, startDate, endDate, search);
  res.fold(
    (_) => {
      dispatch(ordersFailed());
    },
    (r) => {
      dispatch(ordersLoaded(r));
    }
  );
};
